import { fetchFromApi, optionsForPostRequest, optionsForGetRequest } from 'api';

const getPerson = requestBody => fetchFromApi('/person/search', optionsForPostRequest(requestBody));

const getIndividualProfessionalReportPdf = orderId =>
  fetchFromApi(`/person/${orderId}/report/professional/pdf/preview`, optionsForGetRequest());

export default { getPerson, getIndividualProfessionalReportPdf };
